// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit Table Styles */
.audit-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  table-layout: fixed;
}

.audit-table th,
.audit-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

.audit-table th:nth-child(1) { width: 15%; }
.audit-table th:nth-child(2) { width: 15%; }
.audit-table th:nth-child(3) { width: 15%; }
.audit-table th:nth-child(4) { width: 20%; }
.audit-table th:nth-child(5) { width: 25%; }
.audit-table th:nth-child(6) { width: 10%; }

.audit-table th {
  background-color: var(--color-surface-muted);
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
}

.audit-table tr:hover {
  background-color: var(--color-surface-muted);
}

/* Form Controls */
.form-input-sm {
  width: 100%;
  padding: 0.5rem 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-input-sm:focus {
  border-color: var(--color-brand);
  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.18);
}

.form-select-sm {
  width: 100%;
  padding: 0.375rem 1.75rem 0.375rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  background-color: var(--color-surface);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 16px 12px;
  appearance: none;
}

.form-select-sm:focus {
  border-color: var(--color-brand);
  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.18);
}

textarea.form-input-sm {
  min-height: 60px;
  resize: vertical;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  border-radius: var(--radius-control);
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  border: 1px solid transparent;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.btn-primary {
  color: var(--color-on-brand);
  background-color: var(--color-brand);
}

.btn-primary:hover {
  background-color: var(--color-brand-hover);
}

.btn-success {
  color: var(--color-on-brand);
  background-color: var(--color-brand);
}

.btn-success:hover {
  background-color: var(--color-brand-hover);
}

.btn-danger {
  color: var(--color-on-brand);
  background-color: var(--color-danger);
}

.btn-danger:hover {
  background-color: var(--color-danger-hover);
}

.btn-secondary {
  color: var(--color-text);
  background-color: var(--color-surface-muted);
  border-color: var(--color-border);
}

.btn-secondary:hover {
  background-color: var(--color-border);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ml-1 {
  margin-left: 0.25rem;
}

/* Actions Cell */
.actions-cell {
  white-space: nowrap;
  width: 1%;
}

/* Comment Cell */
.comment-cell {
  max-width: 300px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal !important;
}

/* Responsive Table */
.audit-table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 1rem 0;
  border-radius: var(--radius-control);
  border: 1px solid var(--color-border);
  max-width: 100%;
}

/* Empty State */
.audit-empty {
  padding: 2rem;
  text-align: center;
  color: var(--color-text-muted);
  background-color: var(--color-surface-muted);
  border-radius: var(--radius-control);
  margin: 1rem 0;
}

/* Audit Form */
.audit-form {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.audit-form .form-group {
  margin-bottom: 0;
}

.audit-form .form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--color-text);
}

.audit-form .form-input,
.audit-form .form-select,
.audit-form textarea {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--color-text);
  background-color: var(--color-surface);
  background-clip: padding-box;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

textarea.form-input {
  min-height: 100px;
  resize: vertical;
}

.audit-form .form-input:focus,
.audit-form .form-select:focus,
.audit-form textarea:focus {
  border-color: var(--color-brand);
  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.18);
}
`, "",{"version":3,"sources":["webpack://./src/audit-styles.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,+BAA+B,UAAU,EAAE;AAC3C,+BAA+B,UAAU,EAAE;AAC3C,+BAA+B,UAAU,EAAE;AAC3C,+BAA+B,UAAU,EAAE;AAC3C,+BAA+B,UAAU,EAAE;;AAE3C;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,wEAAwE;AAC1E;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,sCAAsC;EACtC,yDAAiP;EACjP,4BAA4B;EAC5B,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;EACf,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,4CAA4C;EAC5C,oCAAoC;EACpC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;EAGE,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;EAC5B,qCAAqC;EACrC,oCAAoC;EACpC,wEAAwE;AAC1E;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;EAGE,gCAAgC;EAChC,wDAAwD;AAC1D","sourcesContent":["/* Audit Table Styles */\n.audit-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  table-layout: fixed;\n}\n\n.audit-table th,\n.audit-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: top;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.audit-table th:nth-child(1) { width: 15%; }\n.audit-table th:nth-child(2) { width: 15%; }\n.audit-table th:nth-child(3) { width: 15%; }\n.audit-table th:nth-child(4) { width: 20%; }\n.audit-table th:nth-child(5) { width: 25%; }\n.audit-table th:nth-child(6) { width: 10%; }\n\n.audit-table th {\n  background-color: var(--color-surface-muted);\n  font-weight: 600;\n  color: var(--color-text);\n  white-space: nowrap;\n}\n\n.audit-table tr:hover {\n  background-color: var(--color-surface-muted);\n}\n\n/* Form Controls */\n.form-input-sm {\n  width: 100%;\n  padding: 0.5rem 0.625rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-input-sm:focus {\n  border-color: var(--color-brand);\n  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.18);\n}\n\n.form-select-sm {\n  width: 100%;\n  padding: 0.375rem 1.75rem 0.375rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  background-color: var(--color-surface);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.5rem center;\n  background-size: 16px 12px;\n  appearance: none;\n}\n\n.form-select-sm:focus {\n  border-color: var(--color-brand);\n  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.18);\n}\n\ntextarea.form-input-sm {\n  min-height: 60px;\n  resize: vertical;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.25rem;\n  border-radius: var(--radius-control);\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n  border: 1px solid transparent;\n}\n\n.btn-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n\n.btn-primary {\n  color: var(--color-on-brand);\n  background-color: var(--color-brand);\n}\n\n.btn-primary:hover {\n  background-color: var(--color-brand-hover);\n}\n\n.btn-success {\n  color: var(--color-on-brand);\n  background-color: var(--color-brand);\n}\n\n.btn-success:hover {\n  background-color: var(--color-brand-hover);\n}\n\n.btn-danger {\n  color: var(--color-on-brand);\n  background-color: var(--color-danger);\n}\n\n.btn-danger:hover {\n  background-color: var(--color-danger-hover);\n}\n\n.btn-secondary {\n  color: var(--color-text);\n  background-color: var(--color-surface-muted);\n  border-color: var(--color-border);\n}\n\n.btn-secondary:hover {\n  background-color: var(--color-border);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ml-1 {\n  margin-left: 0.25rem;\n}\n\n/* Actions Cell */\n.actions-cell {\n  white-space: nowrap;\n  width: 1%;\n}\n\n/* Comment Cell */\n.comment-cell {\n  max-width: 300px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: normal !important;\n}\n\n/* Responsive Table */\n.audit-table-wrapper {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  margin: 1rem 0;\n  border-radius: var(--radius-control);\n  border: 1px solid var(--color-border);\n  max-width: 100%;\n}\n\n/* Empty State */\n.audit-empty {\n  padding: 2rem;\n  text-align: center;\n  color: var(--color-text-muted);\n  background-color: var(--color-surface-muted);\n  border-radius: var(--radius-control);\n  margin: 1rem 0;\n}\n\n/* Audit Form */\n.audit-form {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.audit-form .form-group {\n  margin-bottom: 0;\n}\n\n.audit-form .form-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--color-text);\n}\n\n.audit-form .form-input,\n.audit-form .form-select,\n.audit-form textarea {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--color-text);\n  background-color: var(--color-surface);\n  background-clip: padding-box;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\ntextarea.form-input {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.audit-form .form-input:focus,\n.audit-form .form-select:focus,\n.audit-form textarea:focus {\n  border-color: var(--color-brand);\n  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.18);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
